<template>
    <div v-show="visible">
        <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="450px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-form-item   prop="title" label="标题">
                    <el-input v-model="form.title" maxlength="100" style="width:300px;"></el-input>
                </el-form-item>

                <el-form-item   prop="jumpUrl" label="跳转URL">
                    <el-input v-model="form.jumpUrl" maxlength="100" style="width:300px;"></el-input>
                </el-form-item>

                <el-form-item   prop="orderNum" label="排序号">
                    <el-input v-model="form.orderNum" maxlength="5" type="number" style="width:100px;"></el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="save()">发 布</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                form:{
                    id:"",
                    deptId:"",
                    title:"",
                    jumpUrl:"",
                    orderNum:1
                },
                typeSign:1, // 1-新增，2-修改
                title:"发布公告",
                rules: {
                    title: [
                        { required: true, message: '请输入标题', trigger: 'blur' }
                    ],
                    jumpUrl: [
                        { required: true, message: '请输入跳转URL', trigger: 'blur' }
                    ],
                    orderNum: [
                        { required: true, message: '请输入排序号', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        mounted:function () {
        },
        methods:{
            init(data,typeSign){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.deptId = data.deptId;
                this.typeSign=typeSign;
                
                // 1-新增，2-修改
                if(this.typeSign == 1){
                  this.form.id="";
                  this.form.title="";
                  this.form.jumpUrl="";
                  this.form.orderNum = data.orderNum;
                  this.title = "发布公告";
                }else if(this.typeSign == 2){
                  this.form.id=data.id;
                  this.form.title=data.title;
                  this.form.jumpUrl=data.jumpUrl;
                  this.form.orderNum=data.orderNum;
                  this.title = "修改公告";
                }
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        
                        let url= "";
                        let data = {
                            deptId:this.form.deptId,
                            title:this.form.title,
                            jumpUrl:this.form.jumpUrl,
                            orderNum:this.form.orderNum,
                        };
                        // 1-新增，2-修改
                        if(this.typeSign == 1){
                            url=this.platformNoticeSaveUrl;

                        }else if(this.typeSign == 2){
                            url=this.platformNoticeUpdateUrl;
                            data.id = this.form.id;
                        }
 
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/notice/Send.vue